const LOAD_DATA_PIPELINE_HIRING           = 'LOAD_DATA_PIPELINE_HIRING'
const LOAD_DATA_PIPELINE_HIRING_SUCCESS   = 'LOAD_DATA_PIPELINE_HIRING_SUCCESS'
const LOAD_DATA_PIPELINE_HIRING_FAILED    = 'LOAD_DATA_PIPELINE_HIRING_FAILED'
const UNMOUNT_DATA_PIPELINE_HIRING        = 'UNMOUNT_DATA_PIPELINE_HIRING'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const pipelineHiringReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_PIPELINE_HIRING:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_PIPELINE_HIRING_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_PIPELINE_HIRING_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_PIPELINE_HIRING:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default pipelineHiringReducer;